import { Col, Alert } from 'antd';
import capitalize from 'components/utils/capitalize';
import React from 'react';

export const ResourceSkip = ({
  msg,
  resourceType,
}: {
  msg: string;
  resourceType: string;
}): JSX.Element => {
  return (
    <Col>
      <Alert
        message={capitalize(resourceType)}
        showIcon
        type="info"
        description={capitalize(msg)}
      />
    </Col>
  );
};
